import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  standalone: true,
  imports: [CommonModule, CardModule, DividerModule]
})
export class DeleteAccountComponent {
  constructor() { }

  get currentYear(): number {
    return new Date().getFullYear();
  }
}